import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faBrain, faRobot, faCheck, faArrowRight, faShieldAlt, faArrowLeft, faUser } from '@fortawesome/free-solid-svg-icons';
import { FaFacebook } from 'react-icons/fa';
import {
  OnboardingContainer,
  OnboardingHeader,
  OnboardingTitle,
  OnboardingSubtitle,
  PlatformsContainer,
  NavigationButtons,
  NavigationButton,
  WelcomeSection,
  WelcomeMessage,
  WelcomeHighlight,
  ImportantNotice,
  LogoContainer,
  StartConfigButton
} from './OnboardingStyles';

// Importar o novo componente PlatformGuide
import PlatformGuide from './components/PlatformGuide';
import UserProducts from './components/UserProducts';

const Onboarding = () => {
  const [activePlatform, setActivePlatform] = useState(null);
  const [showWelcome, setShowWelcome] = useState(true);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  
  // Obter dados do usuário ao carregar o componente
  useEffect(() => {
    const userDataFromStorage = localStorage.getItem('userData');
    
    if (!userDataFromStorage) {
      navigate('/auth');
      return;
    }
    
    console.log('Dados do usuário carregados:', userDataFromStorage);
    try {
      const parsedUserData = JSON.parse(userDataFromStorage);
      setUserData(parsedUserData);
    } catch (error) {
      console.error('Erro ao analisar dados do usuário:', error);
      navigate('/auth');
    }
  }, [navigate]);
  
  // Função para iniciar o onboarding
  const startOnboarding = (platform) => {
    setActivePlatform(platform);
    setShowWelcome(false);
    window.scrollTo(0, 0); // Rola a página para o topo
  };
  
  // Função para voltar à tela de boas-vindas
  const backToWelcome = () => {
    setActivePlatform(null);
    setShowWelcome(true);
  };
  
  // Renderizar a seção de boas-vindas
  const renderWelcome = () => (
    <WelcomeSection>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem' }}>
        <img src="/favicon.png" alt="BIANCA Logo" style={{ width: '100px', height: 'auto' }} />
      </div>
      <WelcomeMessage>
        <WelcomeHighlight>
          Bem-vindo à BIANCA
        </WelcomeHighlight>
        <p>Configure as <strong>4 plataformas essenciais</strong> para ativar seu atendimento com IA:</p>
        
        <LogoContainer>
          <div className="platform-item twilio">
            <img src="/twilio_logo.png" alt="Twilio" className="platform-logo" />
            <div className="platform-content">
              <div className="platform-name" style={{ color: '#F22F46' }}>Twilio</div>
              <p>Para gerenciar chamadas telefônicas</p>
            </div>
          </div>
          
          <div className="platform-item meta">
            <img src="/meta_logo.png" alt="Meta" className="platform-logo" style={{ width: 36, height: 36, objectFit: 'contain' }} />
            <div className="platform-content">
              <div className="platform-name" style={{ color: '#1877F3' }}>Meta</div>
              <p>Para integração das campanhas e a API Oficial do Whatsapp</p>
            </div>
          </div>
          
          <div className="platform-item vapi">
            <img src="/vapi_logo.png" alt="Vapi" className="platform-logo" />
            <div className="platform-content">
              <div className="platform-name" style={{ color: '#00A67E' }}>Vapi</div>
              <p>Para processamento de voz</p>
            </div>
          </div>
          
          <div className="platform-item openai" style={{ borderLeft: '4px solid #9B59B6' }}>
            <img src="/openai_logo.png" alt="OpenAI" className="platform-logo" />
            <div className="platform-content">
              <div className="platform-name" style={{ color: '#9B59B6' }}>OpenAI</div>
              <p>Para inteligência artificial</p>
            </div>
          </div>
        </LogoContainer>
        
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
          <StartConfigButton onClick={() => startOnboarding('guide')}>
            Começar Configuração <FontAwesomeIcon icon={faArrowRight} />
          </StartConfigButton>
        </div>
      </WelcomeMessage>
    </WelcomeSection>
  );
  
  // Renderizar o conteúdo principal
  const renderContent = () => {
    if (showWelcome) {
      return renderWelcome();
    } else {
      return (
        <>
          <UserProducts />
          <PlatformGuide />
        </>
      );
    }
  };
  
  return (
    <OnboardingContainer>
      {renderContent()}
      
      {!showWelcome && (
        <NavigationButtons>
          <NavigationButton 
            onClick={backToWelcome}
            subtle
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            Voltar
          </NavigationButton>
        </NavigationButtons>
      )}
    </OnboardingContainer>
  );
};

export default Onboarding;
